import store from 'src/store'
import { FUNCIONALIDADES, funcionalidadeEstaAtiva } from 'src/core/modulos'
import { fonteDeDadosDaApi } from './fonteDeDadosDaApi.js'
import { fonteDeDadosDemonstrativos } from './fonteDeDadosDemonstrativos.js'

export function deveUsarDadosDemonstrativos (location = window.location) {
  const ambienteDemoComercialAtivo = funcionalidadeEstaAtiva(
    store.state,
    FUNCIONALIDADES.AMBIENTE_DEMO_COMERCIAL
  )

  return location.pathname.includes('/comercial/') || ambienteDemoComercialAtivo
}

export function obterFonteDeDadosAcompanhamentoEmTempoReal () {
  return deveUsarDadosDemonstrativos()
    ? fonteDeDadosDemonstrativos
    : fonteDeDadosDaApi
}
